import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "./constants";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";

export const getAdditionalInfoVal = (additionalInfo: any, key: any) => {
    if (!additionalInfo || Object.keys(additionalInfo).length === 0) return null
    else if (typeof additionalInfo[key] === 'object') return additionalInfo[key];
    return JSON.parse(additionalInfo[key]) || null
}

export const normalizedCheckboxes = (docs: any) =>{
const oldDocs = docs?.oldCheckboxes || [];
const newDocs = docs?.docs || [];
const normalizedDocs = oldDocs?.map((checkbox: LangObjectArray) => {
    return {
      type: FormFieldType.LegalDocument,
      header: createDefaultLangObject(' '),
      placeholder: createDefaultLangObject(' '),
      isRequired: false,
      inlineVariants: [],
      fieldIdInCrm: 0,
      isTagInCrm: false,
      isDisabled: false,
      url: '',
      additionalInfo: {
        textAfter: JSON.stringify(createDefaultLangObject('')),
        textBefore: JSON.stringify(createDefaultLangObject('')),
        text:  JSON.stringify(checkbox),
      }
    }
  })

    return [...normalizedDocs, ...newDocs];
  }import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "./constants";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";

export const getAdditionalInfoVal = (additionalInfo: any, key: any) => {
    if (!additionalInfo || Object.keys(additionalInfo).length === 0) return null
    else if (typeof additionalInfo[key] === 'object') return additionalInfo[key];
    return JSON.parse(additionalInfo[key]) || null
}

export const normalizedCheckboxes = (docs: any) =>{
const oldDocs = docs?.oldCheckboxes || [];
const newDocs = docs?.docs || [];
const normalizedDocs = oldDocs?.map((checkbox: LangObjectArray) => {
    return {
      type: FormFieldType.LegalDocument,
      header: createDefaultLangObject(' '),
      placeholder: createDefaultLangObject(' '),
      isRequired: false,
      inlineVariants: [],
      fieldIdInCrm: 0,
      isTagInCrm: false,
      isDisabled: false,
      url: '',
      additionalInfo: {
        textAfter: JSON.stringify(createDefaultLangObject('')),
        textBefore: JSON.stringify(createDefaultLangObject('')),
        text:  JSON.stringify(checkbox),
      }
    }
  })

    return [...normalizedDocs, ...newDocs];
  }